import { render, staticRenderFns } from "./RulesForm.vue?vue&type=template&id=2d238bbc&scoped=true&"
import script from "./RulesForm.vue?vue&type=script&lang=js&"
export * from "./RulesForm.vue?vue&type=script&lang=js&"
import style0 from "./RulesForm.vue?vue&type=style&index=0&id=2d238bbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d238bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCheckbox,VCol,VForm,VRow,VSubheader})
